<template>
  <!-- remove the v-if if you want the links clickable during transitions -->
  <!-- BEWARE: Removing the v-if causes conference videos to be shown early -->
  <div class="overlay" ref="overlay" v-if="videoEnded">
    <div
      class="item"
      v-for="(item, index) in filteredVideoElements"
      :class="{ highlight: highlightItems && item.isHighlightable, disabled: item.disabled, under: item.type === 'tooltip' }"
      :key="index"
      :style="getStyle(item)"
    >
      <div
        v-if="item.type === 'video'"
		:class="item.css_class"
        class="open-modal"
        @click="openModal(item /*uses item.link*/)"
      ></div>
      <div
        v-if="item.type == 'screen' && item.link"
        ref="screen"
        class="screen"
		:class="item.css_class"
      >
        <screen-overlay-component
          :item="item"
          :isChatOpen="isChatOpen"
        ></screen-overlay-component>
			</div>
			<a
				v-if="item.type === 'external'"
				:class="item.css_class"
				:href="item.link"
				target="_blank"
				@click="checkMixpanel(item)"
			></a>
			<router-link
				v-if="item.type === 'internal'"
				:class="item.css_class"
				:to="item.link"
			></router-link>
			<a v-if="item.type === 'back'" @click="handleBack" :class="item.css_class"></a>
			<a v-if="item.type === 'public'" @click="handlePublic" :class="item.css_class"></a>
			<a v-if="item.type === 'support'" @click="handleSupport" :class="item.css_class"></a>
			<a v-if="item.type === 'chat' && item.link" @click="handleChat(item)" :class="item.css_class"></a>
			<div
				v-if="item.type === 'html-modal'"
				class="open-modal"
				:class="item.css_class"
				@click="openHtmlModal(item)"
			></div>
			<div v-if="item.type === 'likes'" class="vote-wrap" :class="item.css_class">
				<div @click="castVote(item)" :class="{'voted' : item.isVoted}" class="vote-button">{{ item.isVoted ? $t('newblock.videoOverlay.voted') : $t('newblock.videoOverlay.vote') }}</div>
				<div class="vote-counter">{{ getVotesFormatted(item) }}</div>
			</div>
			<Slido v-if="item.type === 'slido' && !isMobile" :link='item.link' :itemClass="item.css_class"/>
			<VideoTooltip v-if="item.type === 'tooltip'" :item="item" />
			<ApiLink v-if="item.type === 'bbb_modal'" :item="item" />
			<ApiLink v-if="item.type === 'bbb_external'" :item="item" />
			<OpenBoothChatButton v-if="item.type === 'booth-chat'" :item="item" />
			<ContactButton v-if="item.type === 'contact'" :item="item" />
			<SubscribeButton v-if="item.type === 'subscribe'" :item="item" />
			<RequestMeetButton v-if="item.type === 'request_meet'" :item="item" />
			<HtmlRender v-if="item.type.toLowerCase() === 'html'" :item="item"/>
		</div>
	</div>
</template>

<script>
import api from "@/api";
import axios from "axios";
import ScreenOverlayComponent from './ScreenOverlayComponent'
import Slido from '@/components/slido/Slido.vue'
import isMobileMixin from "@/mixins/isMobileMixin"
import VideoTooltip from "./VideoTooltip.vue"
import ApiLink from "./contact-clickable-elements/ApiLink.vue"
import OpenBoothChatButton from "./contact-clickable-elements/OpenBoothChatButton"
import ContactButton from "./contact-clickable-elements/ContactButton.vue"
import SubscribeButton from "./contact-clickable-elements/SubscribeButton.vue"
import RequestMeetButton from "./contact-clickable-elements/RequestMeetButton.vue"
import HtmlRender from "./contact-clickable-elements/HtmlRender.vue"

export default {
	mixins: [isMobileMixin],
	components: {
		ScreenOverlayComponent,
		Slido,
		VideoTooltip,
		ApiLink,
    OpenBoothChatButton,
		ContactButton,
		SubscribeButton,
		RequestMeetButton,
		HtmlRender
	},
	props: {
		videoElements: {
			type: Array,
			default: () => []
		},
		highlightItems: {
			type: Boolean,
			default: false
		},
		videoEnded: {
			type: Boolean,
			default: true
		},
		boothName: {
			type: String,
			default: ''
		}
	},
	computed: {
		filteredVideoElements () {
			return this.videoElements.filter(el => {
				if (el.coords) {
			// disable highlight on tooltip content type
			el.isHighlightable = !['tooltip'].includes(el.type);
					let c = el.coords;
					if (
						c.top !== null && 
						c.bottom !== null && 
						c.left !== null && 
						c.right !== null &&
						c.top !== undefined && 
						c.bottom !== undefined && 
						c.left !== undefined && 
						c.right !== undefined
					) return true
				}
			}) 
		}
	},
	data() {
		return {
			stream: null,
			refreshInt: null,
		};
	},
	watch: {
		videoElements: {
			deep: true,
			handler () {
				setTimeout(() => {
					this.checkForRefreshVotes();
				}, 0);
			}
		}
	},
	beforeDestroy() {
		this.stopRefreshVotes();
	},
	methods: {
		checkForRefreshVotes() {
			for (const item of this.videoElements) {
				if (item.type === 'likes') {
					this.startRefreshVotes();
				}
			}
		},
		stopRefreshVotes () {
			if (this.refreshInt) {
				clearInterval(this.refreshInt);
				this.refreshInt = null
			}
		},
		startRefreshVotes () {
			this.stopRefreshVotes();
			this.refreshInt = setInterval(async () => {
				try {
					let res = await api.getVotes(this.boothName);
					let votes = res.data.count;
					this.updateVotes(votes);
				} catch (error) {
					this.handleError(error);
				}
			}, 10 * 1000);
		},
		updateVotes (votes) {
			let checkForAlterVotes = (item, newVotes, timeout = 200) => {
				if (timeout < 100) timeout = 100;
				if (newVotes > item.numOfLikes) {
					this.$set(item, 'numOfLikes', item.numOfLikes+1);
					setTimeout(() => {
						checkForAlterVotes(item, newVotes, timeout - 10);
					}, timeout);
				}
			}
			let item = this.videoElements.filter((el) => {
				if (el.type === 'likes') return el;
			})[0]
			checkForAlterVotes(item, votes)
		},
		getVotesFormatted(item) {
			let ogVotes = String(item.numOfLikes)
			let formattedVotes = [];
			for (let i = 0; i < 4 - ogVotes.length; i++) {
				formattedVotes[i] = '0'
			}
			formattedVotes.push(ogVotes);
			return formattedVotes.join('');
		},
		async castVote(item) {
			if (item.isVoted === true) {
				this.handleError(new Error(this.$t('newblock.videoOverlay.alreadyVoted')));
				return;
			}
			try {
				let res = await axios.post( process.env.VUE_APP_VIDEO_BASE + item.link, {
					sid: localStorage.getItem('sid')
				});
				if (res.data.result === 'ok') {
					this.$set(item, 'isVoted', true);
					this.$set(item, 'numOfLikes', item.numOfLikes+1);
				}
			} catch (error) {
				this.handleError(error);
			}
		},
		getSlidoFixedWidth() {
			let getScreenWidth = () => {
				let overlay = this.$refs.overlay
				if (overlay) return Math.floor(overlay.getBoundingClientRect().width)

        return Math.max(
          document.body.scrollWidth,
          document.documentElement.scrollWidth,
          document.body.offsetWidth,
          document.documentElement.offsetWidth,
          document.documentElement.clientWidth
        );
      };
      // i need to calculate 350px but in % for current screen width
      let screenWidth = getScreenWidth();
      return screenWidth - 350;
    },
    getStyle(item) {
      let coords = item.coords;
      if (item.type === "slido") {
        if (!item.link || this.isMobile) return;
        let slidoWidth = this.getSlidoFixedWidth();
        return {
          top: 0,
          bottom: 0,
          right: 0,
          left: slidoWidth + "px",
        };
      }
      if (
        coords.top === null &&
        coords.bottom === null &&
        coords.left === null &&
        coords.right === null
      ) {
        return {
          display: "none",
        };
      }
      return {
        top: coords.top + "%",
        bottom: 100 - coords.bottom + "%",
        left: coords.left + "%",
        right: 100 - coords.right + "%",
      };
    },
    openModal(item) {
      this.postEventTracking({code:"booth_video_played",data:""});
      this.$emit("open-modal", item.link);
    },
    handleSupport() {
      this.EventBus.$emit("support-chat");
    },
    handleChat(item) {
      this.EventBus.$emit("chatProp", {
        location: "dm",
        userId: item.link, // userId
      });
    },
    handlePublic() {
      this.EventBus.$emit("chatProp", {
        location: "public",
      });
    },
    openHtmlModal(item) {
		this.checkMixpanel(item);
		this.EventBus.$emit("open-html-modal", item);
	},
    handleBack() {
      this.goBack();
    },
    checkMixpanel(item) {
      if (!item || !item.code || !item.booth) return;
      let event = null;
      switch (item.code) {
        case "brochure":
          event = `download_brochure_${item.booth}`;
          break;
        case "meeting":
          event = `clicked_schedule_meeting_${item.booth}_button`;
          break;
      }
      if (item.type == 'external') {
        this.postEventTracking({code:"booth_file_download",data:""});
      }
      if (!event) return;
      console.log("Mixpanel event: ", item.code);
      api.mixpanel({ event });
    },
  },
};
</script>

<style scoped lang="scss">
.vote-wrap {
  cursor: default;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #c4c4c4;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  .vote-button {
    cursor: pointer;
    font-size: 24px;
    font-weight: 900;
    margin-left: 5px;
    height: calc(100% - 15px);
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #5a5353;
    color: #fff;
    border-radius: 5px;
    &.voted {
      // cursor: default;
      background: #b3b3b3;
      color: #5a5353;
    }
  }
  .vote-counter {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: transparent;
    color: #fff;
    font-size: 26px;
    font-weight: 900;
    margin-right: 13px;
  }
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.item {
	position: absolute;
	cursor: pointer;
	border-radius: 10px;
	transition: background-color 0.5s ease;
	z-index: 2;
}
.highlight {
  background-color: #54549499;
}
.under {
	z-index: 1;
}
.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 7vh;
  height: 7vh;
  background: #ffffff88;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  color: #777;
  span {
    font-size: 40px;
  }
}
a,
.open-modal {
  width: 100%;
  height: 100%;
  display: block;
}
.screen {
  position: relative;
  height: 100%;
  width: 100%;
  max-height: 100% !important;
  max-width: 100% !important;
}

.pervent-click {
  pointer-events: none;
}
.disabled {
  display: none;
}
</style>
